// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FvnvU","footer":"styles_footer__36WGm"};